import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import styles from './styles.module.scss';

const Chip = ({
	star,
	blank,
	active,
	title,
	value,
	onClick,
	theme,
	noWrap = false,
	...rest
}) => {
	const chipCx = cx(styles.Chip, {
		[styles.Chip_blank]: blank,
		[styles.Chip_active]: active,
		[styles.Chip_noWrap]: noWrap
	});

	const toggleHandler = (event) => {
		onClick(event);
	};

	return (
		<button
			type="button"
			onClick={toggleHandler}
			data-value={value}
			className={cx(chipCx, styles[`Chip_theme_${theme}`])}
			data-cy="chip"
			{...rest}
		>
			{star && <Icon icon="star" className={styles.Chip__Star} />}
			{title}
		</button>
	);
};

Chip.propTypes = {
	title: PropTypes.node,
	star: PropTypes.bool,
	onClick: PropTypes.func,
	value: PropTypes.any,
	blank: PropTypes.bool,
	active: PropTypes.bool,
	theme: PropTypes.oneOf(['outline']),
	noWrap: PropTypes.bool
};

Chip.defaultProps = {
	onClick: _.noop
};

export default Chip;
